// extracted by mini-css-extract-plugin
export default {"wrapper":"DistributionOrders_wrapper__OKmms","noWrap":"DistributionOrders_noWrap__OQQaz","downloadButton":"DistributionOrders_downloadButton__Vs4Gh"};